import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NewsFeedItemHeaderBase } from '../news-feed-item-header-base';
import { FiProfileSizes } from '@fi-shared/profile-icon/profile-icon.component';

@Component({
    selector: 'fi-news-feed-item-header-post',
    templateUrl: './news-feed-item-header-post.component.html',
    styleUrls: ['./news-feed-item-header-post.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class NewsFeedItemHeaderPostComponent extends NewsFeedItemHeaderBase {
    FiProfileSizes = FiProfileSizes;
}
